export default __webpack_public_path__ + "9e25e265ff142687de1c9daa28d67bd4.mov";